<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
        >添加</el-button
      >
      <el-button
        type="success"
        size="mini"
        @click="getList"
        >刷新</el-button
      >
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      > -->
      <el-button
        slot="reference"
        type="danger"
        size="mini"
        style="margin-left: 10px"
        @click="openDelete"
        >删除</el-button
      >
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 941px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="id" label="理财ID" width="100" />
      <el-table-column prop="name" label="名字" width="100" />
      <el-table-column prop="withdrawSum" label="产品配图" width="140">
        <template slot-scope="scoped">
          <el-image
            style="width: 60px;"
            :src="scoped.row.image"
            fit="fill"
            :preview-src-list="new Array(scoped.row.image)"
            @click.stop="handleClickItem"
          />
        </template>
      </el-table-column>
      <el-table-column prop="financialDay" label="理财周期" width="100" />
      <el-table-column prop="earnPro" label="总收益率" width="100">
        <template slot-scope="scoped">
          <div v-if="scoped.row.earnPro">{{ scoped.row.earnPro }}%</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="earnDay" label="每日收益率" width="100">
        <template slot-scope="scoped">
          <div v-if="scoped.row.earnDay">{{ scoped.row.earnDay }}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="receiveHour" label="分红周期" width="100">
        <template slot-scope="scoped">
          <div v-if="scoped.row.receiveHour">
            {{ scoped.row.receiveHour }}小时
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="receiveHour" label="USDT购买限制" width="150">
        <template slot-scope="scoped">
          <div>
            {{ scoped.row.customMinPrice || 0 }}~{{
              scoped.row.customMaxPrice || 0
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="receiveHour" label="状态" width="100">
        <template slot-scope="scoped">
          <div v-if="scoped.row.isEnable" style="color: #06cc00">开启</div>
          <div v-if="!scoped.row.isEnable" style="color: #ff0000">禁用</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="active" label-width="150px" size="mini">
        <el-form-item label="名字">
          <el-input v-model="active.name" placeholder="请输入名字" />
        </el-form-item>
        <el-form-item label="产品配图">
          <UploadImage ref="imageEn" @upLoadImage="upLoadImage1"></UploadImage>
        </el-form-item>
        <el-form-item label="理财天数">
          <el-input
            v-model="active.financialDay"
            placeholder="请输入理财天数"
          />
        </el-form-item>
        <el-form-item label="总收益率">
          <el-input v-model="active.earnPro" placeholder="请输入总收益率" />%
        </el-form-item>
        <el-form-item label="USDT购买限制">
          <el-input
            v-model="active.customMinPrice"
            style="width: 180px"
            placeholder="请输入最小购买金额限制"
          />
          ～
          <el-input
            v-model="active.customMaxPrice"
            style="width: 180px"
            placeholder="请输入最大购买金额限制"
          />
        </el-form-item>
        <el-form-item label="设置">
          <el-checkbox v-model="isEnable">启用</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
            <el-button slot="reference" type="primary" class="edit-button"
              >添加</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      width="700px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="editForm" label-width="150px" size="mini">
        <el-form-item label="名字">
          <el-input v-model="active.name" placeholder="请输入名字" />
        </el-form-item>
        <el-form-item label="产品配图">
          <UploadImage ref="images" @upLoadImage="upLoadImage2"></UploadImage>
        </el-form-item>
        <el-form-item label="理财天数">
          <el-input
            v-model="editForm.financialDay"
            placeholder="请输入理财天数"
          />
        </el-form-item>
        <el-form-item label="总收益率">
          <el-input
            v-model="editForm.earnPro"
            placeholder="请输入总收益率"
          />%
        </el-form-item>
        <el-form-item label="购买金额限制">
          <el-input
            v-model="editForm.customMinPrice"
            style="width: 180px"
            placeholder="请输入最小购买金额限制"
          />
          ～
          <el-input
            v-model="editForm.customMaxPrice"
            style="width: 180px"
            placeholder="请输入最大购买金额限制"
          />
        </el-form-item>
        <el-form-item label="设置">
          <el-checkbox v-model="editForm.isEnable">启用</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="investUpdate()">
            <el-button slot="reference" type="primary" class="edit-button"
              >添加</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap, UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: {},
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], //
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      editDialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      num: 24,
      isEnable: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    upLoadImage1(img) {
      this.active.image = img;
    },
    upLoadImage3(img) {
      this.active.imageTrx = img;
    },
    upLoadImage2(img) {
      this.editForm.image = img;
    },
    upLoadImage4(img) {
      this.editForm.imageTrx = img;
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 编辑
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.images.init(this.editForm.image);
        this.$refs.imageTrx1.init(this.editForm.imageTrx);
      });
    },
    investUpdate() {
      this.$api.operate
        .investUpdate(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.editDialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .investList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .investDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
      this.dialogVisible = true;
      this.isEnable = false
      this.active = {}
      this.$nextTick(() => {
        this.$refs.imageEn.init('');
        this.$refs.imageTrx.init('');
      });
    },
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d;
    },
    // 添加用户
    bannerSave() {
      this.active.isEnable = this.isEnable;
      this.$api.operate
        .investSave(this.active)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
